export default "__VITE_ASSET__C6kE80re__"